import { Switch, SwitchProps } from '@headlessui/react';
import { Fragment, useState, useEffect } from 'react';

import styles from './Toogle.module.scss';

export interface ToogleProps extends SwitchProps {
  testId: string;
}

export const Toogle = ({ testId, ...props }: ToogleProps) => {
  const [checked, setChecked] = useState<boolean>(props.checked || false);

  useEffect(() => {
    if (props.checked !== undefined) {
      setChecked(props.checked);
    } else {
      setChecked(false);
    }
  }, [props.checked]);

  return (
    <Switch {...props} checked={checked} as={Fragment}>
      {({ checked }) => (
        <span
          className={styles.toogle}
          data-test-id={`${testId}-container`}
          data-checked={checked}
          data-disabled={props.disabled}
        >
          <div className={styles.dot} />
        </span>
      )}
    </Switch>
  );
};
